<template>
    <div>
        <div class='main_mid' v-if='isShow'>
            <div class='dataPreviewTitle'>
                <div class='top_tips '><span class='ml20'>数据结果</span></div>
                <div class='download' @click='downLoadData'>
                    <i class='iconfont icon-xiazai'></i>下载数据
                </div>
            </div>
            <el-table :data='previewData'>
                <el-table-column v-for='(item, index) in previewColumns' :key='index' :label='item.tableNmae'
                                 width='180'>
                    <template #default='scope'>
                        {{ scope.row[item.tableField] }}
                    </template>
                    <template>
                        <el-table-column v-for='(subItem, subIndex) in item.children' :key='subIndex'
                                         :label='subItem.label' width='90'>
                            <template #default='scope'>
                                {{ scope.row[subItem.tableNmae] }}
                            </template>
                        </el-table-column>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @current-change='currentChange'
                layout='prev, pager, next'
                :total='previewPagination.total'>
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { dataPreview } from '@/utils/api';

export default {
    props: {
        downLoadData: {
            type: Function,
            default: () => () => {
            }
        },
        apiUrl: {
            type: String,
            default: () => ''
        },
        queryParameters: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            previewPagination: {
                page: 1,
                total: 0,
                size: 10
            },
            previewColumns: [],
            previewData: [],
            isShow: false
        };
    },
    methods: {
        //查询数据
        queryTheData(type = 1) {
            if (type === 1) {
                this.previewPagination.page = 1;
            }
            this.isShow = true;
            setTimeout(() => {
                const to_select_data = {
                    ...this.queryParameters,
                    ...this.previewPagination
                };
                dataPreview(this.apiUrl, to_select_data).then(res => {
                    this.previewPagination.total = res.data && res.data.data && res.data.data.totalCount;
                    this.previewColumns = res.data && res.data.nameLine.map(item => {
                        return {
                            tableNmae: item.comment,
                            tableField: item.name
                        };
                    });
                    this.previewData = res.data.data.list;
                });
            });

        },
        //页码改变
        currentChange(current) {
            this.previewPagination.page = current;
            this.queryTheData(2);
        }
    }
};
</script>

<style scoped lang='scss'>
.main_mid {
    position: relative;
    width: 90%;
    padding: 30px 80px 80px 80px;
    border-radius: 10px 10px 0px 0px;
    margin-left: -1%;
    margin-top: 30px;
    background: #fff;

    .dataPreviewTitle {
        display: flex;
        align-items: center;

        .download {
            margin-left: 20px;
            cursor: pointer;
            margin-bottom: 30px;
            color: #271B63;
            font-size: 16px;
            display: flex;
            align-items: center;

            i {
                margin-right: 5px;
                background: rgb(240, 240, 255);
                font-size: 26px;
            }
        }
    }

    .el-pagination {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
    }

    .serch_list {
        min-height: 140px;
        border: 1px solid #002D72;
        margin-top: 30px;
        padding: 0 0 30px;
        display: flex;
        flex-wrap: wrap;

        .list_item {
            width: 15%;
            height: 50px;
            font-size: 18px;
            color: #271B63;
            margin: 30px 2.5% 0 2.5%;
        }

        .list_item {
            opacity: 0.8;
            cursor: pointer;
        }
    }

    .serch_box {
        /deep/ .el-input__inner {
            width: 300px;
            margin-right: 5px;
        }
    }

    .time_select {
        width: 400px;

        /deep/ .el-icon-date {
            font-size: 20px;
        }
    }
}
</style>
